import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { GridOptions } from "ag-grid/main";
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import * as $ from 'jquery';

import { AssessmentSummary, AgGridUtility, SINGLE_ROW_HEADER, DOUBLE_ROW_HEADER, DateUtility, DELETE_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, } from '../shared';
import { CommonUtility, ServerConstantsService, DataService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import { TextEditorComponent } from '../shared/components/text-editor.component';
import { YearEditorComponent } from '../shared/components/year-editor.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-education-certification',
  templateUrl: './education-certification.component.html',
  styleUrls: ['./education-certification.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class EducationCertificationComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  isDisabled = false;
  serverConstants: any;
  sharedData: any;
  tabIndex: any = "-1";

  highSchoolName: string;
  highSchoolGraduationYearcd: string;
  highestEducationCd: string;
  userActionNotificationsMap;
  hSGradYearJson;
  highestEducationNameDescJson;
  educationLevelDescReverseJson;
  educationLevelDescJson;
  educationArray = [];
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;

  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  isCurrentEnrollment:Boolean = false;
  assessmentId: Number;
  assessment: AssessmentSummary;
  personId: Number;
  //Education
  educations: Educations[] = [];
  removedEducations: Educations[] = [];
  show = false;

  educationsColumnDefs: any;
  educationAuditColumnDefs: any;
  context: any;
  defaultColDef;
  editType;
  gridApi;
  answerApi;
  gridColumnApi;
  components;
  gridOptions;
  tabToNextCell: any;
  agGridOptions: GridOptions;
  educationOptions: GridOptions;
  certificationOptions: GridOptions;


  //Certification

  certificationTypeDescJson: any;
  certificationTypeDescReverseJson: any;
  licenseCertificateTypeDescJson;
  licenseCertificateTypeDescReverseJson;
  federalLicenseReverseJson;
  federalLicenseJson;
  federalLicenseArray = [];
  stateLicenseReverseJson;
  stateLicenseJson;
  stateLicenseArray = [];
  professionalCertificationReverseJson;
  professionalCertificationJson;
  professionalCertificationArray = [];
  technicalCertificationReverseJson;
  technicalCertificationJson;
  technicalCertificationArray = [];
  reverseMapCetification;
  mapCetification;
  mapCetificationCd;
  licenseCertArray = [];
  arrayCetification;


  gridCertificationApi;
  gridCertificationColumnApi;

  certificationColumnDefs: any;
  certificationAuditColumnDefs: any;
  certificationContext: any;
  certifications: Certification[] = [];
  certificationArray = [];
  removedCertification: Certification[] = [];
  userFullName;
  rowSelection;

  answers = [];
  answersColumnDefs;
  frameworkComponents;

  validationError = [];
  showError = false;
  certificationShowError = false;
  certificationValidationError = [];
  requiredFields = ['PD', 'MS', 'BS', 'HS', 'GE', 'AS'];
  isRequired = false;

  isShowStyle = false;
  readOnly = false;
  isChangeDetected = false;


  constructor(

    private router: Router,
    private renderer: Renderer,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private datePipe:DatePipe
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.agGridOptions = <GridOptions>{};
    this.educationOptions = <GridOptions>{};
    this.certificationOptions = <GridOptions>{};
    if (this.dataService.getSharedDataObject().get('ASMNT') == undefined) {
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {
    //this.fileInput.nativeElement.click()
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get("ASMNT").innerNavPages.find(x => x.pageId === 'ASMEC').readOnly;
    if (this.readOnly == true) {
      this.tabIndex = "0";
    }
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    this.hSGradYearJson = this.data.getValueFromSharedDataMap("HSGradYear");
    this.highestEducationNameDescJson = this.data.getValueFromSharedDataMap('HighestEducationNameDesc');
    const educationLevelDesc = this.data.getValueFromSharedDataMap('EducationLevelDesc');
    educationLevelDesc.forEach(element => {
      this.educationArray.push(element.name);
    });
    this.educationLevelDescReverseJson = this.commonUtil.createReverseNativeMapFromList(educationLevelDesc);
    this.educationLevelDescJson = this.commonUtil.createNativeMapFromList(educationLevelDesc);

    const licenseCertificateTypeDesc = this.data.getValueFromSharedDataMap('LicenseCertificateTypeDesc');
    licenseCertificateTypeDesc.forEach(element => {
      this.licenseCertArray.push(element.name);
    });
    this.licenseCertificateTypeDescReverseJson = this.commonUtil.createReverseNativeMapFromList(licenseCertificateTypeDesc);
    this.licenseCertificateTypeDescJson = this.commonUtil.createNativeMapFromList(licenseCertificateTypeDesc);

    const federalLicense = this.data.getValueFromSharedDataMap('FederalLicense');
    federalLicense.forEach(element => {
      this.federalLicenseArray.push(element.name);
    });
    this.federalLicenseReverseJson = this.commonUtil.createReverseNativeMapFromList(federalLicense);
    this.federalLicenseJson = this.commonUtil.createNativeMapFromList(federalLicense);

    const stateLicense = this.data.getValueFromSharedDataMap('StateLicense');
    stateLicense.forEach(element => {
      this.stateLicenseArray.push(element.name);
    });
    this.stateLicenseReverseJson = this.commonUtil.createReverseNativeMapFromList(stateLicense);
    this.stateLicenseJson = this.commonUtil.createNativeMapFromList(stateLicense);

    const professionalCertification = this.data.getValueFromSharedDataMap('ProfessionalCertification');
    professionalCertification.forEach(element => {
      this.professionalCertificationArray.push(element.name);
    });
    this.professionalCertificationReverseJson = this.commonUtil.createReverseNativeMapFromList(professionalCertification);
    this.professionalCertificationJson = this.commonUtil.createNativeMapFromList(professionalCertification);

    const technicalCertification = this.data.getValueFromSharedDataMap('TechnicalCertification');
    technicalCertification.forEach(element => {
      this.technicalCertificationArray.push(element.name);
    });
    this.technicalCertificationReverseJson = this.commonUtil.createReverseNativeMapFromList(technicalCertification);
    this.technicalCertificationJson = this.commonUtil.createNativeMapFromList(technicalCertification);


    this.reverseMapCetification = {
      "State License": this.stateLicenseReverseJson,
      "Federal License": this.federalLicenseReverseJson,
      "Technical Certification": this.technicalCertificationReverseJson,
      "Professional Certification": this.professionalCertificationReverseJson
    };

    this.mapCetification = {
      "State License": this.stateLicenseJson,
      "Federal License": this.federalLicenseJson,
      "Technical Certification": this.technicalCertificationJson,
      "Professional Certification": this.professionalCertificationJson
    };

    this.mapCetificationCd = {
      "SL": this.stateLicenseJson,
      "FL": this.federalLicenseJson,
      "TC": this.technicalCertificationJson,
      "PC": this.professionalCertificationJson
    };

    this.arrayCetification = {
      "State License": this.stateLicenseArray,
      "Federal License": this.federalLicenseArray,
      "Technical Certification": this.technicalCertificationArray,
      "Professional Certification": this.professionalCertificationArray
    };



    // Shared object access to get personId and assessmentId
    this.sharedData = this.dataService.getSharedDataObject();

    if (this.sharedData.get('assessmentId') !== null && this.sharedData.get('assessmentId') !== undefined) {
      this.assessmentId = Number(this.sharedData.get('assessmentId'));
    }

    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      this.personId = Number(this.sharedData.get('wpPersonId'));
    }





    this.getColumnDefinitions();
    this.getColumnDefinitionsCertification();
    this.getColumnDefinitionsAnswer();
    // Education-Audit Column Defenations
    this.getEducationAuditColumnDefs();
    //Certification-Audit Column Definations
    this.getCertificationAuditColumnDefs();

    if (this.assessmentId > 0) {
      const request = new RequestLoad(this.assessmentId);
      this.load(request);

    }

    if (this.sharedData.get('selectedEnrollmentEndDt') !== null && this.sharedData.get('selectedEnrollmentEndDt') !== undefined
     && this.sharedData.get('selectedEnrollmentEndDt') !== "Current") {
      this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

    console.log('isDisabled : ' + this.isDisabled);
    console.log('readOnly : ' + this.readOnly);
    console.log('!isCurrentEnrollment : ' + !this.isCurrentEnrollment);
    console.log('selectedEnrollmentEndDt : ' + this.sharedData.get('selectedEnrollmentEndDt'));

  }

  onHighEducationChange() {
    if ((this.highSchoolGraduationYearcd === undefined || this.highSchoolGraduationYearcd === null || this.highSchoolGraduationYearcd === "") && this.requiredFields.includes(this.highestEducationCd)) {
      this.isRequired = true;
    } else {
      this.isRequired = false;
    }
  }
  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }



  checkYear(value) {
    if (value !== undefined) {
      const currentYear = (new Date()).getFullYear()
      const less100Years = currentYear - 100;
      return !((value <= currentYear) && (value > less100Years));
    }
    return true;
  }
  getColumnDefinitions() {
    this.educationsColumnDefs = [
      {
        headerName: 'Education', field: 'educationCd', editable: !(this.isDisabled || this.readOnly), cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: this.educationArray,

        }, cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && params.value === 'Pick an option') {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'School', field: 'schoolName', cellEditor: "textEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && (params.value === undefined || params.value.trim().length === 0)) {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Field of Study', width: 170, field: 'fieldOfStudy', cellEditor: "textEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && (params.value === undefined || params.value.trim().length === 0)) {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Degree Obtained', width: 190, field: 'degreeObtained', cellEditor: "textEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && (params.value === undefined || params.value.trim().length === 0)) {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Year Obtained', width: 170, field: 'yearObtained', cellEditor: "yearEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && (params.value === undefined || that.checkYear(params.value))) {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Action', width: 110, field: '', cellRenderer: this.getEducationActionButtons,
        suppressFilter: true,
        suppressSorting: true
      }
    ];

    this.context = {
      component: this,
    };
    this.rowSelection = "multiple";
    this.components = { datePicker: this.getDatePicker() };
    this.gridOptions = {
      context: {
        componentParent: this
      }
    };
    this.frameworkComponents = {
      textEditor: TextEditorComponent,
      yearEditor: YearEditorComponent
    };
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === "Action") {
        return;
      }
      else {
        return nextCell;
      }
    }
  }

  getEducationAuditColumnDefs() {
    this.educationAuditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        width: 160,
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        width: 195,
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'Education',
        field: 'educationCd',
        refData: this.educationLevelDescJson,
        width: 195,
        tooltip: (params) => {
          const educationLevelDescMap = params.context.educationLevelDescJson;
          const educationLevelCode = params.data.educationCd;
          const educationLevel = educationLevelDescMap[educationLevelCode];
          return educationLevel;
        }
      },
      {
        headerName: 'School',
        field: 'schoolName',
        width: 195,
        tooltipField: 'schoolName'
      },
      {
        headerName: 'Field Of Study',
        field: 'fieldOfStudy',
        width: 170,
        tooltipField: 'fieldOfStudy'
      },
      {
        headerName: 'Degree Obtained',
        field: 'degreeObtained',
        width: 195,
        tooltipField: 'degreeObtained'
      },
      {
        headerName: 'Year Obtained',
        field: 'yearObtained',
        width: 170,
        tooltipField: 'yearObtained'
      }
    ];
  }

  onEducationGridReady(params) {
    this.gridApi = params.api;
    this.educationOptions.api = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      // this.agGridOptions.columnDefs = this.educationsColumnDefs;
    }
    else {
      this.agGridOptions.api.sizeColumnsToFit();
      this.educationOptions.api.sizeColumnsToFit();
      this.certificationOptions.api.sizeColumnsToFit();
    }
  }

  onGridCertificationReady(params) {
    this.gridCertificationApi = params.api;
    this.certificationOptions.api = params.api;
    this.gridCertificationColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }
  onGridAnswerReady(params) {
    this.answerApi = params.api;
    this.agGridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onCertificationPaginationChanged(event) {
    if (this.gridApi) {
      this.setDisplayedRowAtIndex1();
    }
  }

  onEducationPaginationChanged(event) {
    if (this.gridApi) {
      this.setDisplayedRowAtIndex();
    }
  }

  addEventListenerToCertification(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.certifications.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex1();
  }
  addEventListenerToRecords(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.answers.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex2();
  }

  addEventListenerToSearch(event) {
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.educations.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }
    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtAddNew() {
    var index = this.educations.length -1;
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }


  setDisplayedRowAtIndex() {
    // get the first row
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }
  setDisplayedRowAtIndex1() {
    // get the first row
    var index = this.gridCertificationApi.getFirstDisplayedRow();
    var rowNode = this.gridCertificationApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    this.gridCertificationApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridCertificationApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridCertificationApi.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtIndex2() {
    // get the first row
    var index = this.answerApi.getFirstDisplayedRow();
    var rowNode = this.answerApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    this.answerApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.answerApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.answerApi.setFocusedCell(index, firstCol);
  }

  focusHeader(event) {
    if (this.certifications.length === 0) {
      this.addEventListenerToRecords(event);
    }
    else {
      this.addEventListenerToCertification(event);
    }
  }


  getColumnDefinitionsCertification() {
    this.certificationColumnDefs = [

      {
        headerName: 'License/Certification', field: 'certificationCd', editable: !(this.isDisabled || this.readOnly), cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: this.licenseCertArray

        }, cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;

          if (that.isShowStyle && params.value === 'Pick an option') {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }

        }, onCellValueChanged: function (params) {
          params.data.typeCd = undefined;
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        },
      },
      {
        headerName: 'Type', field: 'typeCd', editable: !(this.isDisabled || this.readOnly), cellEditor: "agSelectCellEditor",
        cellEditorParams: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          const selectedCert = params.data.certificationCd;
          const selectList = that.arrayCetification[selectedCert];

          return {
            values: selectList,

          };
        }, cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          const selectedCert = params.data.certificationCd;

          if (that.isShowStyle && (selectedCert === undefined || (that.reverseMapCetification[selectedCert] !== undefined &&
            (params.value === undefined || params.value === "Pick an option")))) {
            params.data.typeCd = "Pick an option";
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },


      {
        headerName: 'Year Obtained', width: 170, field: 'yearObtained', cellEditor: "yearEditor", editable: !(this.isDisabled || this.readOnly), cellStyle: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          if (that.isShowStyle && (params.value === undefined || that.checkYear(params.value))) {
            return { border: '1px solid red' };
          } else {
            return { border: 'none' };
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Action', width: 110, field: '', cellRenderer: this.getCertificationAuditButtons,
        suppressFilter: true,
        suppressSorting: true
      }
    ];


  }

  getCertificationAuditColumnDefs() {
    this.certificationAuditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime
      },
      {
        headerName: 'License/Certification',
        field: 'certificationCd',
        refData: this.licenseCertificateTypeDescJson,
        tooltip: (params) => {
          const licenseCertificateDescMap = params.context.licenseCertificateTypeDescJson;
          const licenseCertificateCode = params.data.certificationCd;
          const licenseCertificate = licenseCertificateDescMap[licenseCertificateCode];
          return licenseCertificate;
        }
      },
      {
        headerName: 'Type',
        field: 'typeCd',
        valueGetter: this.getCertficationType,
        tooltip: this.getCertficationType
      },
      {
        headerName: 'Year Obtained',
        field: 'yearObtained',
        tooltipField: 'yearObtained'
      }
    ];
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === "Action") {
        return;
      }
      else {
        return nextCell;
      }
    }
  }

  getCertficationType(params) {
    const mapCertificationCode = params.context.mapCetificationCd;
    const typeCode = params.data.typeCd;
    const certificationCode = params.data.certificationCd;
    const selectedCertificationCd = mapCertificationCode[certificationCode];
    let selectedTypeCd;
    try {
      selectedTypeCd = selectedCertificationCd[typeCode];
    } catch (e) {
      selectedTypeCd = '';
    }
    return selectedTypeCd;
  }

  getColumnDefinitionsAnswer() {
    this.answersColumnDefs = [
      { headerName: 'School', field: 'SCHOOL_NAME' },
      { headerName: 'Major', field: 'MAJOR' },
      { headerName: 'Degree Obtained', width: 150, field: 'DEGREE_OBTAINED' },
      { headerName: 'Begin Date', width: 150, field: 'BEGIN_DT' },
      { headerName: 'Expected Graduation Date', field: 'EXPECTED_GRAD_DT' },
      { headerName: 'End Date', width: 130, field: 'END_DT' }

    ];
  }


  reset() {
    if (this.assessmentId > 0) {

      this.load(new RequestLoad(this.assessmentId));

    }
  }

  getEducationActionButtons(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    // Delete Button
    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute("class", "disabled");
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteEducation(params.data.assessment.id)
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.deleteEducation(params.data.assessment.id);
      }
      else if (event.keyCode == 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute("tabindex", "0");
    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");

    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.setAttribute("style", "z-index:2");
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentEducation');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.educationAuditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Education Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory'])
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentEducation');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.educationAuditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Education Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory'])
      }
    });
    auditElement.setAttribute("tabindex", "0");

    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  getCertificationAuditButtons(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    // Delete Button
    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute("class", "disabled");
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteCertification(params.data.assessment.id)
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.deleteCertification(params.data.assessment.id);
      }
      else if (event.keyCode == 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute("tabindex", "0");

    const divCol1 = document.createElement('div');
    divCol1.setAttribute("class", "col-2 right-margin-1");

    divCol1.appendChild(element);

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentCertification');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.certificationAuditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Certification Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory'])
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentCertification');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.certificationAuditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Certification Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory'])
      }
    });
    auditElement.setAttribute("tabindex", "0");

    const divCol2 = document.createElement('div');
    divCol2.setAttribute("class", "col-1");
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }


  load(request) {
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/loadObjects/education', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment-Educations & Certifications', this.userActionNotificationsMap.ERROR);
        } else {

          if (data !== null && data !== undefined && data.educations !== undefined) {
            this.educations = data.educations;

            this.educations.forEach(selectedRow => {
              selectedRow.educationCd = this.educationLevelDescJson[selectedRow.educationCd];

            });
            console.log('service: ' + JSON.stringify(this.educations));
          } else {
            this.educations = [];

          }
          if (data !== null && data !== undefined && data.certifications !== undefined) {
            this.certifications = data.certifications;
            this.certifications.forEach(selectedRow => {
              selectedRow.certificationCd = this.licenseCertificateTypeDescJson[selectedRow.certificationCd];

              if (selectedRow.typeCd !== undefined && selectedRow.typeCd.length > 0) {
                selectedRow.typeCd = this.mapCetification[selectedRow.certificationCd][selectedRow.typeCd];

              }


            });
          } else {
            this.certifications = [];

          }
          if (data !== null && data !== undefined && data.assessment !== undefined) {

            this.assessment = data.assessment;
            if (this.assessment.statusCd !== undefined && /*(this.assessment.statusCd === 'CO') || */(this.assessment.statusCd === 'CN')) {
              this.isDisabled = true;
              this.tabIndex = "0";
              this.getColumnDefinitions();
              this.getColumnDefinitionsCertification();
            }
            this.highSchoolName = this.assessment.highSchoolName;
            this.highSchoolGraduationYearcd = this.assessment.highSchoolGraduationYearcd;
            this.highestEducationCd = this.assessment.highestEducationCd;
            this.onHighEducationChange();

          } else {

          }
          this.validationError = [];
          this.certificationValidationError = [];
          this.showError = false;
          this.certificationShowError = false;
        }
      }, response => {

        this.notificationService.error('Assessment-Educations & Certifications', this.userActionNotificationsMap.ERROR);
      }, () => {

      });

    // this.http.post<PersonEducationAnswer[]>(this.serverConstants.COMMON_SERVER_API_URL +
    //   '/answer/education', { "personId": this.personId }).subscribe(
    //     (data: PersonEducationAnswer[]) => {
    //       if (data !== undefined && data !== undefined && data.hasOwnProperty('errorCode')) {
    //         this.notificationService.error('Assessment-Educations & Certifications', this.userActionNotificationsMap.ERROR);

    //       } else {
    //         if (data !== null && data !== undefined && data !== undefined && data.length > 0) {

    //           data.forEach(selectedRow => {
    //             selectedRow.beginDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.beginDt);
    //             selectedRow.endDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.endDt);
    //             selectedRow.expectedGradDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.expectedGradDt);

    //           })
    //           this.answers = data;
    //         }
    //         else {
    //           this.answers = [];
    //         }
    //       }
    //     });
    (this.sharedData.get('personProvider').conversionStat === 'CM') ? this.loadAriesData() : this.loadAnswerData();
  }


//   {
//     "SCHOOL_NAME": "BK",
//     "MAJOR": "Business",
//     "DEGREE_OBTAINED": "  ",
//     "BEGIN_DT": "11/1/2018 12:00:00 AM",
//     "EXPECTED_GRAD_DT": "10/1/2018 12:00:00 AM",
//     "END_DT": null
// }
  loadAnswerData() {
    const ssnValue = this.sharedData.get('SSN_SEARCH');

    this.http.get<PersonEducationAnswer[]>(this.serverConstants.SERVER_API_URL + '/SNAPWorks/GetClientEducationAndCertification/'
      + ssnValue).subscribe(
        (educations: PersonEducationAnswer[]) => {
          if (educations !== undefined  && educations.hasOwnProperty('errorCode')) {
            // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
            // The existing yellow toast notification to be removed so commented the below
            // this.notificationService.warn('Assessment-Educations & Certifications', 'Education Records not found in ANSWER');

          } else {
            if (educations !== null && educations !== undefined && educations.length > 0) {
              educations.forEach(rows => {
                if (rows.BEGIN_DT !== undefined && rows.BEGIN_DT !== null) {
                rows.BEGIN_DT = this.dateUtil.formatDateMDY(rows.BEGIN_DT);
                }
                if (rows.END_DT !== undefined && rows.END_DT !== null) {
                  rows.END_DT = this.dateUtil.formatDateMDY(rows.END_DT);
                }
                if (rows.EXPECTED_GRAD_DT !== undefined && rows.EXPECTED_GRAD_DT !== null) {
                  rows.EXPECTED_GRAD_DT = this.dateUtil.formatDateMDY(rows.EXPECTED_GRAD_DT);
                }
              });
              this.answers = educations;
            } else {
              this.answers = [];
            }
          }
        },
        response => {
          this.notificationService.warn('Assessment-Educations & Certifications', 'Education Records not found in Eligibility System');
        },
        () => {
        });

  }

  loadAriesData() {
    const value = this.sharedData.get('personProvider').emciId;

    this.http.get(this.serverConstants.SERVER_API_URL + '/SNAPWorks/Aries/eduInfo/'
      + value).subscribe(
        (educations: Array<Object>) => {
          if (educations !== undefined  && educations.hasOwnProperty('errorCode')) {
            // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
            // The existing yellow toast notification to be removed so commented the below
            // this.notificationService.warn('Assessment-Educations & Certifications', 'Education Records not found in ANSWER');
            this.notificationService.warn('Assessment-Educations & Certifications', 'Education Records not found in Eligibility System');

          } else {
            if (educations !== null && educations !== undefined && educations.length > 0) {
              let eduHistory=[];
              educations.forEach(rows => {
                let record = {
                  SCHOOL_NAME : null,
                  MAJOR: null,
                  DEGREE_OBTAINED: null,
                  BEGIN_DT: null,
                  EXPECTED_GRAD_DT: null,
                  END_DT: null
                };
                if (rows["effBeginDt"] !== undefined && rows["effBeginDt"] !== null) {
                  record.BEGIN_DT = this.datePipe.transform(new Date(rows["effBeginDt"]), 'MM/dd/yyyy');
                }
                if (rows["effEndDt"] !== undefined && rows["effEndDt"] !== null) {
                  record.END_DT = this.datePipe.transform(new Date(rows["effEndDt"]), 'MM/dd/yyyy');
                }
                if (rows["highSchGradDt"] !== undefined && rows["highSchGradDt"] !== null) {
                  record.EXPECTED_GRAD_DT = this.datePipe.transform(new Date(rows["highSchGradDt"]), 'MM/dd/yyyy');
                }
                record.SCHOOL_NAME = rows["instiName"];
                record.MAJOR = rows["educationLevelCd"];
                eduHistory.push(record);
              });
              this.answers = eduHistory;
            } else {
              this.answers = [];
            }
          }
        },
        response => {
          this.notificationService.warn('Assessment-Educations & Certifications', 'Education Records not found in Eligibility System');
        },
        () => {
        });

  }

  addEducation() {

    const response = this.gridApi.updateRowData({ add: [this.createNewRowData()] });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, "educationCd");
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: "educationCd"
    });
    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }

  createNewRowData() {
    const newEducation: Educations = new Educations(this.assessment, 'N');
    return newEducation;
  }

  deleteEducation(assessmentId) {
    const selectedData: Educations[] = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedData });
    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedEducations.push(element);
      }
    })
  }

  addCertification() {
    const response = this.gridCertificationApi.updateRowData({ add: [new Certification(this.assessment, 'N', this.userFullName)] });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridCertificationApi.setFocusedCell(index, "certificationCd");
    this.gridCertificationApi.startEditingCell({
      rowIndex: index,
      colKey: "certificationCd"
    });
    this.gridCertificationApi.paginationGoToPage( Math.floor(index / 10) );
  }
  deleteCertification(assessmentId) {
    const selectedData = this.gridCertificationApi.getSelectedRows();
    this.gridCertificationApi.updateRowData({ remove: selectedData });

    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removedCertification.push(element);
      }
    })
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  saveAll() {
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    this.fileInput.nativeElement.click();
    this.isChangeDetected = false;
    this.gridApi.stopEditing();
    this.gridCertificationApi.stopEditing();
    this.isShowStyle = true;
    this.gridApi.redrawRows();
    this.gridCertificationApi.redrawRows();
    this.isShowStyle = false;
    this.gridApi.selectAll();
    const allEducations: Educations[] = this.gridApi.getSelectedRows();
    this.gridApi.deselectAll();
    this.validationError = [];
    this.showError = false;
    let errorIndex = 0;
    let isHeaderPushed = false;
    allEducations.forEach(selectedRow => {
      ++errorIndex;
      let errorText = "";
      if (selectedRow.educationCd === undefined || selectedRow.educationCd === "Pick an option") {
        errorText = "Education, ";
      } if (selectedRow.schoolName === undefined || selectedRow.schoolName.trim().length === 0) {
        errorText = errorText + "School Name, ";
      } if (selectedRow.fieldOfStudy === undefined || selectedRow.fieldOfStudy.trim().length === 0) {
        errorText = errorText + "Field of Study, ";
      } if (selectedRow.degreeObtained === undefined || selectedRow.degreeObtained.trim().length === 0) {
        errorText = errorText + "Degree Obtained, ";
      } if (selectedRow.yearObtained === undefined) {
        errorText = errorText + "Year Obtained, ";
      } else if (this.checkYear(selectedRow.yearObtained)) {
        this.validationError.push("Row " + errorIndex + ": " + "Year Obtained should be current year or within past 100 years");
        this.showError = true;
      }
      if (errorText.length > 0) {
        setTimeout(() => this.fileInput.nativeElement.focus(), 0);
        this.fileInput.nativeElement.click();
        if (!isHeaderPushed) {
          isHeaderPushed = true;
          this.validationError.push("Following fields are mandatory:");
        }

        errorText = errorText.substring(0, errorText.length - 2);
        this.validationError.push("Row " + errorIndex + ": " + errorText);
        this.showError = true;
      }

    });




    this.gridCertificationApi.selectAll();
    const allCertification: Certification[] = this.gridCertificationApi.getSelectedRows();

    this.gridCertificationApi.deselectAll();
    this.certificationValidationError = [];
    this.certificationShowError = false;
    errorIndex = 0;
    isHeaderPushed = false;
    allCertification.forEach(selectedRow => {

      ++errorIndex;
      let errorText = "";
      if (selectedRow.certificationCd === undefined || selectedRow.certificationCd === "Pick an option") {
        errorText = "License / Certification, ";
      } if (this.reverseMapCetification[selectedRow.certificationCd] !== undefined &&
        (selectedRow.typeCd === undefined || selectedRow.typeCd === "Pick an option")) {
        errorText = errorText + "Type, ";
      } if (selectedRow.yearObtained === undefined) {
        errorText = errorText + "Year Obtained, ";
      } else if (this.checkYear(selectedRow.yearObtained)) {
        this.certificationValidationError.push("Row " + errorIndex + ": " + "Year Obtained should be current year or past 100 years");
        this.certificationShowError = true;
      }
      if (errorText.length > 0) {
        if (!isHeaderPushed) {
          isHeaderPushed = true;
          this.certificationValidationError.push("Following fields are mandatory:");
        }

        errorText = errorText.substring(0, errorText.length - 2);
        this.certificationValidationError.push("Row " + errorIndex + ": " + errorText);
        this.certificationShowError = true;
      }

    });



    if (!this.showError && !this.certificationShowError) {
      this.removedEducations.forEach(element => {
        allEducations.push(element);
      });
      this.removedCertification.forEach(element => {
        allCertification.push(element);
      });
      allEducations.forEach(selectedRow => {
        selectedRow.educationCd = this.educationLevelDescReverseJson[selectedRow.educationCd];


      });

      allCertification.forEach(selectedRow => {
        if (selectedRow.typeCd !== undefined && selectedRow.typeCd.length > 0 && this.reverseMapCetification[selectedRow.certificationCd] !== undefined) {
          selectedRow.typeCd = this.reverseMapCetification[selectedRow.certificationCd][selectedRow.typeCd];
        } else {
          selectedRow.typeCd = "";
        }
        selectedRow.certificationCd = this.licenseCertificateTypeDescReverseJson[selectedRow.certificationCd];


      });


      this.assessment.highSchoolName = this.highSchoolName;
      this.assessment.highSchoolGraduationYearcd = this.highSchoolGraduationYearcd;

      this.assessment.highestEducationCd = this.highestEducationCd;
      const request = new RequestLoadAll(allEducations, allCertification, this.assessment);
      this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/saveEducation', request).subscribe(
        (data) => {
          if (data.hasOwnProperty('errorCode')) {
            this.notificationService.error('Assessment-Educations & Certifications', this.userActionNotificationsMap.ERROR);
          } else {
            this.isChangeDetected = false;
            this.notificationService.success('Assessment-Educations & Certifications', this.userActionNotificationsMap.ADD);
            setTimeout(() => this.headerText.nativeElement.focus(), 0);
            this.headerText.nativeElement.click();
            if (this.assessmentId > 0) {

              this.load(new RequestLoad(this.assessmentId));
              this.removedEducations = [];
              this.removedCertification = [];
            }
          }
        }, response => {

          this.notificationService.error('Assessment-Educations & Certifications', this.userActionNotificationsMap.ERROR);
        }, () => {

        });
    }
  }



  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }
  getDatePicker() {


    function Datepicker() { }
    Datepicker.prototype.init = function (params) {
      this.eInput = document.createElement("input");
      this.eInput.value = params.value;

      ($(this.eInput) as any).datepicker({ dateFormat: "mm/dd/yy" });
    };
    Datepicker.prototype.getGui = function () {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function () {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function () {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function () { };
    Datepicker.prototype.isPopup = function () {
      return false;
    };
    return Datepicker;
  }


  printResult(res) {
    console.log("---------------------------------------");
    if (res.add) {
      res.add.forEach(function (rowNode) {
        console.log("Added Row Node", rowNode);
      });
    }
    if (res.remove) {
      res.remove.forEach(function (rowNode) {
        console.log("Removed Row Node", rowNode);
      });
    }
    if (res.update) {
      res.update.forEach(function (rowNode) {
        console.log("Updated Row Node", rowNode);
      });
    }
  }
}

class RequestLoad {
  constructor(
    public id: Number,

  ) {
  }
}

class Educations {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public schoolName?: string,
    public educationCd?: string,
    public yearObtained?: number,
    public fieldOfStudy?: string,
    public degreeObtained?: string,
    public id?: any,
    public recordVersion?: number

  ) {
  }
}

class Certification {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public certificationCd: string,
    public typeCd?: string,
    public yearObtained?: number,
    public id?: any,
    public recordVersion?: number

  ) {
  }
}



class RequestLoadAll {
  constructor(
    public educations: any,
    public certifications: any,
    public assessment: AssessmentSummary,
  ) {
  }
}

class PersonEducationAnswer {
  constructor(
    public SCHOOL_NAME: string,
    public MAJOR: string,
    public DEGREE_OBTAINED: string,
    public BEGIN_DT: any,
    public EXPECTED_GRAD_DT: any,
    public END_DT: any
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/education-certification/education-certification.component.ts